import customFetch from "~/composables/custom-fetch";
import {useConfigStore} from "~/shared/store/modules/config";
import type {IReqConfig} from "~/shared/interfaces/api";
import type {IServerConfig} from "~/shared/interfaces/config";
import type {EventHandlerRequest, H3Event} from "h3";

export default defineNuxtPlugin(async (nuxtApp) => {

  const configStore = useConfigStore();

  try {
    const data = await useFetch<IServerConfig>('/api/config/getConfig');
    if (data.data.value) {
      configStore.setConfig(data.data.value);
    }
  } catch (error) {
    console.error('Error fetching config:', error);
  }

  nuxtApp.provide('customFetch', (opts: IReqConfig, event?: H3Event<EventHandlerRequest>) => customFetch(opts, event));
});
